// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-up-down-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.5 9.5L16.5 13.5L20.5 9.5M16.5 12.25V3.5M3.5 14.5L7.5 10.5L11.5 14.5M7.5 11.75V20.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowUpDown2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-up-down-2',
    ref,
    icon: element,
  },
));

ArrowUpDown2Icon.displayName = 'ArrowUpDown2Icon';

export default ArrowUpDown2Icon;
